module.exports = __webpack_public_path__ + "img/flag-2.cc52c998.png";